var map = {
	"./1.png": "./src/images/CentralWyndham/1.png",
	"./2.png": "./src/images/CentralWyndham/2.png",
	"./3.png": "./src/images/CentralWyndham/3.png",
	"./4.png": "./src/images/CentralWyndham/4.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/images/CentralWyndham sync recursive \\.(png%7Cjpe?g%7Csvg)$";